import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { Customerservice } from 'src/app/model/customerservice.model';
import { CustomergroupService } from 'src/app/services/customergroup.service';

@Component({
  standalone: false,
  selector: 'app-list-service-group',
  templateUrl: './list-service-group.component.html',
  styleUrls: ['./list-service-group.component.scss']
})
export class ListServiceGroupComponent implements OnInit {

  public customerservice = new Customerservice();
  private subscriptions = new Subscription();

  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  parkId: any;
  mainGroups = [];
  newMainGroups = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private customergroupService: CustomergroupService,
  ) {
    localStorage.setItem('expandNavUser', 'true');

    const route = this.sideNavService.routingChunks({
      name: 'Users',
      subNav: '3',
      subNavLink: '',
      //subNavLink: '/landscaping-and-vegetation/list-of-plants-trees',
    });
    this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {

    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.getTheMainServiceGroupList();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavUser');
    this.subscriptions.unsubscribe();
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  searchByText(event: any) {
    console.log(event);
    console.log(this.mainGroups);

    this.newMainGroups = this.mainGroups.filter((item: { groupName: any }) => {
      return item.groupName.toLowerCase().includes(event.toLowerCase());
    });
    this.totalRows = this.newMainGroups?.length;

    console.log(this.newMainGroups);
    if (event == '') {
      this.totalRows = this.mainGroups?.length;
      console.log(this.newMainGroups);
    }
  }

  handelServiceGroupList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  goToServiceGroupDetails(id) {
    this.router.navigate(['/member-by-group/' + id]);
  }

  getTheMainServiceGroupList() {

    const groupListPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
    };

    this.parkId = localStorage.getItem('parkId');

    this.customergroupService.getMainGroupList().subscribe((res) => {
      if (res?.isValid === true) {
        this.mainGroups = res?.list;
        this.newMainGroups = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.mainGroups = [];
        this.newMainGroups = [];
        this.totalRows = 0;
      }
    });
  }
}
